/** @format */

import { RoutesPath } from "./RoutesPath";

import { lazyLoad } from "../utils/lazyLoad";

const Blank = lazyLoad(() => import("../pages/Blank/Blank"));
const InitialPage = lazyLoad(() => import("../pages/Initial/Initial"));
const Createsmscampaign = lazyLoad(() => import("../pages/createsmscampaign"));
const Dashboard = lazyLoad(() => import("../pages/dashboard"));
const CreateContactList = lazyLoad(() => import("../pages/CreateContactList"));
const SMSCampaignHistory = lazyLoad(() =>
  import("../pages/smscampaignhistory")
);
const SMSHistoryDetailPage = lazyLoad(() =>
  import("../pages/smshistorydetailpage")
);
const SMSCreateList = lazyLoad(() => import("../pages/smscampaignlist"));
const Login = lazyLoad(() => import("../pages/NewLogin/NewLogin"));
const CreateContact = lazyLoad(() => import("../pages/createContact"));
const List = lazyLoad(() => import("../pages/list"));

const routes = [
  {
    path: RoutesPath.INITIAL_PAGE,
    element: InitialPage,
    isProtected: false,
  },
  {
    path: RoutesPath.LOGIN,
    element: Login,
    isProtected: false,
  },
  {
    path: RoutesPath.DASHBOARD,
    element: Dashboard,
    isProtected: true,
  },
  {
    path: RoutesPath.CREATECONTACT,
    element: CreateContactList,
    isProtected: true,
  },
  {
    path: RoutesPath.CAMPAIGNHISTORY,
    element: SMSCampaignHistory,
    isProtected: true,
  },
  {
    path: RoutesPath.CAMPAIGNHISTORYDETAILS,
    element: SMSHistoryDetailPage,
    isProtected: true,
  },
  {
    path: RoutesPath.SMSCAMPAIGN,
    element: Createsmscampaign,
    isProtected: true,
  },

  {
    path: RoutesPath.LISTDETAILS,
    element: SMSCreateList,
    isProtected: true,
  },
  {
    path: RoutesPath.CONTACT,
    element: CreateContact,
    isProtected: true,
  },
  {
    path: RoutesPath.LIST,
    element: List,
    isProtected: true,
  },
  {
    path: RoutesPath.BLANK,
    element: Blank,
    isProtected: true,
  },
];

export default routes;
